import ApiService from "services/ApiService";

const TestJourneyService = {
    getAllJourneys: async function ({ projectId, page, limit = 10, searchQuery = '', sortConfig = { key: 'created_at', direction: 'desc', archived: false } }) {
        const endpoint = `/journeys/project/${projectId}?page=${page}&limit=${limit}&search=${searchQuery}&sort_key=${sortConfig.key}&sort_direction=${sortConfig.direction}&archived=${sortConfig.archived}`;
        return await ApiService.get(endpoint);
    },
    createJourney: async function (
        {projectId, name, pageId}
    ) {
        const endpoint = `/journeys/project/${projectId}`;
        return await ApiService.post(endpoint, {
            name, pageId
        });
    },
    archiveJourney: async function (id) {
        const endpoint = `/journeys/archive/${id}`;
        return await ApiService.post(endpoint);
    },
    unarchiveJourney: async function (id) {
        const endpoint = `/journeys/unarchive/${id}`;
        return await ApiService.post(endpoint);
    },
    deleteJourney: async function (idArray) {
        const endpoint = `/journeys?ids=${idArray}`;
        return await ApiService.post(endpoint);
    },
};

export default TestJourneyService;
